// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketClose$ReactHooksTemplate = require("./ticketClose.res.js");

function TicketCloseView(props) {
  var activity = props.activity;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Ticket Closed",
                              className: "text-sm font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: TicketClose$ReactHooksTemplate.user_email(activity),
                              className: "text-xs font-normal"
                            })
                      ],
                      className: "flex justify-between text-darkcharcoal"
                    }),
                JsxRuntime.jsx("div", {
                      children: TicketClose$ReactHooksTemplate.comment(activity),
                      className: "mt-2 text-xs font-normal"
                    })
              ]
            });
}

var make = TicketCloseView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
